import { useMemo, useRef } from 'react';
import type { IUseChatProps } from './types';
import {
	useStartConnection,
	useConnectionInitEffect,
} from './connection.hooks';
import { useProviderListeners } from './providerListeners.hooks';

/**
 * Orchestrates the full chat lifecycle: connection initialisation,
 * start/reconnect logic and provider event listeners.
 *
 * Message side-effects are handled internally by each hook that needs them.
 */
export const useInitChat = (props: IUseChatProps) => {
	const { params, onConnection, onWebMessage } = props;
	const timestampRef = useRef<string>(undefined);

	const { startConnection, resetRetries } = useStartConnection(timestampRef);

	const connectionInitParams = useMemo(
		() => ({ timestampRef, startConnection }),
		[startConnection],
	);
	useConnectionInitEffect(connectionInitParams);

	const listenerParams = useMemo(
		() => ({
			params,
			onConnection,
			onWebMessage,
			timestampRef,
			startConnection,
			resetRetries,
		}),
		[params, onConnection, onWebMessage, startConnection, resetRetries],
	);
	useProviderListeners(listenerParams);
};
